if (!customElements.get('avelen-shop')) {
  customElements.define('avelen-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const slides = this.querySelector('.av-shop-slides');
      const thumbs = [...this.querySelectorAll('[data-slide]')];
      thumbs.forEach(button => button.addEventListener('click', () => {
        slides.scrollTo({ left: slides.clientWidth * Number(button.dataset.slide), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      slides?.addEventListener('scroll', () => {
        const index = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      }, { passive: true });
      const variants = JSON.parse(this.querySelector('[data-av-plans]')?.textContent || '{}');
      const money = cents => new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      const planSelect = form?.querySelector('[name="selling_plan"]');
      let lastVariant;
      const update = () => {
        const selected = form?.querySelector('input[name="id"]:checked');
        const variant = variants[selected?.value];
        if (!variant) return;
        const plans = variant.plans.filter(plan => plan.recurring);
        const subscription = form.querySelector('[value="subscription"]');
        const once = form.querySelector('[value="onetime"]');
        this.querySelector('[data-subscription-choice]').hidden = !plans.length;
        subscription.disabled = !plans.length;
        if (!plans.length) once.checked = true;
        if (lastVariant !== selected.value) {
          planSelect.value = plans[0]?.id || '';
          lastVariant = selected.value;
        }
        const plan = plans.find(plan => String(plan.id) === planSelect.value) || plans[0];
        const recurring = subscription.checked && !!plan;
        planSelect.disabled = !recurring;
        const price = recurring ? plan.price : variant.price;
        this.querySelectorAll('span[data-price],[data-button-price],[data-sticky-price]').forEach(node => node.textContent = money(price));
        this.querySelector('[data-onetime-price]').textContent = money(variant.price);
        this.querySelector('[data-subscription-price]').textContent = plan ? money(plan.price) + ' / delivery' : '';
        this.querySelector('[data-subscription-saving]').textContent = plan && plan.price < variant.price ? Math.round((variant.price - plan.price) / variant.price * 100) + '%' : '';
        const compare = this.querySelector('[data-compare]');
        compare.hidden = !recurring || price >= variant.price;
        compare.textContent = money(variant.price);
        this.querySelectorAll('[data-offer-price]').forEach(node => {
          const offer = variants[node.dataset.offerPrice];
          const offerPlan = offer?.plans.find(item => item.recurring);
          const offerPrice = recurring && offerPlan ? offerPlan.price : offer.price;
          node.textContent = money(offerPrice);
          const index = Object.keys(variants).indexOf(node.dataset.offerPrice) + 1;
          const base = Object.values(variants)[0].price * index;
          const saving = this.querySelector('[data-offer-saving="' + node.dataset.offerPrice + '"]');
          saving.textContent = base > offerPrice ? 'Save ' + money(base - offerPrice) : '';
        });
        const terms = this.querySelector('[data-recurring-terms]');
        terms.textContent = '';
        terms.hidden = true;
        const submit = form.querySelector('[type="submit"]');
        submit.disabled = !variant.available;
        form.querySelector('[data-button-label]').textContent = 'ADD TO CART';
      };
      form?.addEventListener('change', update);
      update();
      let busy = false;
      form?.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.querySelector('input[name="id"]:checked:not(:disabled)')) return;
        busy = true;
        const submit = form.querySelector('[type="submit"]');
        const error = form.querySelector('.av-shop-error');
        const success = form.querySelector('.av-shop-success');
        error.hidden = true;
        success.hidden = true;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const selected = form.querySelector('input[name="id"]:checked');
          const item = { id: selected.value, quantity: 1 };
          if (!planSelect.disabled && planSelect.value) item.selling_plan = planSelect.value;
          const items = [item];
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message);
          location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
          return;
        } catch (failure) {
          error.textContent = failure.message || 'Please try again or contact us for help.';
          error.hidden = false;
        } finally {
          busy = false;
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        }
      });
      const sticky = this.querySelector('.av-mobile-shop');
      if (sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > innerHeight;
        });
        this.observer.observe(this.querySelector('.av-shop-info'));
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
  });
}
